// Layout.jsx
// Wraps every page with Navbar + main + Footer.
// Reads from siteConfig so no props needed at the page level.

import Navbar from "Layout/navbar"
import Footer from "Layout/footer"

const Layout = ({ children, layout }) => (
	<div className="min-h-screen flex flex-col bg-bg-page">
		<Navbar brand={layout?.brand} nav={layout?.nav} cta={layout?.cta} authLinks={layout?.authLinks} banner={layout.banner} />
		<main className="flex-1">{children}</main>
		<Footer brand={layout?.brand} links={layout?.footer?.links} />
	</div>
)

export default Layout
